<template>
  <div class="wrapper">
    <div class="outer">
      <div class="inner">
        <div class="wrap">
          <header>
            <h1 class="bi">
              보이스캐디 스마트 골프 서비스
            </h1>
          </header>
          <main>
            <ul class="form">
              <li>
                <input type="text" v-model="userId" placeholder="아이디를 입력하세요" />
              </li>
              <li>
                <input type="password" v-model="userPw" placeholder="비밀번호를 입력하세요" v-on:keyup.enter="loginBtn" />
              </li>
            </ul>
            <div class="save">
              <label>
                <input type="checkbox" v-model="staySignedIn" />
                <i></i>
                로그인 상태 유지
              </label>
            </div>
          </main>
          <footer>
            <div class="button">
              <!-- 비활성(Attribute) : disabled -->
              <button @click="loginBtn" :disabled="userId === '' || userPw === ''">
                로그인
              </button>
            </div>
            <div class="forget">
              <div class="item">
                비밀번호를 잊으셨나요?
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'

export default {
  data () {
    return {
      userId: '',
      userPw: '',
      staySignedIn: false
    }
  },
  computed: {
    loggingIn () {
      return this.$store.state.users.status.loggedIn
    }
  },
  created () {
    this.$store.dispatch('users/logout')
  },
  mounted () {
    if (navigator.userAgent.match(/iP(hone|od|ad)/)) {
      document.getElementsByName('viewport')[0].setAttribute('content', 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=0')
    } else {
      document.getElementsByName('viewport')[0].setAttribute('content', 'width=device-width, initial-scale=1.0')
    }
  },
  methods: {
    loginBtn (e) {
      const { userId, userPw, staySignedIn } = this
      const { dispatch } = this.$store
      if (userId !== '' && userPw !== '') {
        if (userId && userPw) {
          dispatch('users/login', {userId, userPw, staySignedIn}).then(() => {
            const token = this.$store.state.users.user.data.token
            if (!window.apl) return false
            window.apl.loginSuccess(jwtDecode(token).accountId, token)
          })
        } else {
          alert('아이디와 비밀번호를 입력해주세요')
        }
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/LO001.vue